import { render, staticRenderFns } from "./PriceInfo.vue?vue&type=template&id=be8d81cc&scoped=true&"
import script from "./PriceInfo.vue?vue&type=script&lang=js&"
export * from "./PriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./PriceInfo.vue?vue&type=style&index=0&id=be8d81cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8d81cc",
  null
  
)

export default component.exports